import _ from 'lodash';
//import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import FMPHeadline from '../../components/ui/FMPHeadline';
import InventoryAllocationsContainer from '../../containers/inventory/InventoryAllocations';
import PricingPopupIcon from '../../images/icons/pricingPopup.svg';
import documentIcon from '../../images/document.svg';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
import { valueToDisplay } from '../../libs/products';
import FormComponent from '../../components/FormComponent';
import FMPMonthYearPicker from '../../components/pureForm/FMPMonthYearPicker';
import IconButton from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
// import {sortTable} from "../../libs/utility";
import WarningIcon from '@material-ui/icons/Warning';

const reasonToDisplay = {
	activeContract: 'Active Contract',
	previousMonthRollOver: 'Previous Rollover',
	interTankTransfer: 'Tank Transfer',
	other: 'Other',
};

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	pricingIcon: {
		marginRight: 12,
		display: 'inline-block',
		width: 34,
		height: 31,
		backgroundImage: `url('${PricingPopupIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
	documentIcon: {
		marginRight: 12,
		display: 'inline-block',
		width: 34,
		height: 40,
		backgroundImage: `url('${documentIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
	docContainer: {
		position: 'absolute',
	},
	missingCost: {
		fontWeight: 900,
		color: '#FF500F',
	},
	dontNeedCostYet: {
		color: '#888',
		fontWeight: 300,
	},
	hasCost: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	contractNumber: {
		fontSize: '90%',
		color: '#666',
	},
	warningIcon: {
		color: '#FFC107',
		width: 16,
		height: 16,
		paddingRight: 5,
		borderRight: '1px solid #f1f1f1',
		verticalAlign: 'middle',
	},
});

const columns = [
	{
		sortId: 'terminalSupplierSort',
		displayId: 'terminalSupplierDisplay',
		labels: ['Terminal', 'Supplier / Loading #'],
	},
	{
		sortId: 'activeContractsSort',
		displayId: 'activeContractsDisplay',
		label: 'Active Contracts',
	},
	{
		sortId: 'allocationSourcesSort',
		displayId: 'allocationSourcesDisplay',
		label: 'Allocation Sources',
	},
	{
		sortId: 'quickAddRollover',
		displayId: 'quickAddRollover',
		label: 'Add Rollover',
	},
	{
		sortId: 'totalAllocation',
		displayId: 'totalAllocationDisplay',
		label: 'Allocation Volumes',
	},
	{
		//	sortId: 'totalByDelivery',
		//	displayId : 'totalByDeliveryDisplay',
		//	label : 'All Deliveries',
		//}, {
		sortId: 'deliveryVsInvoiceDiff',
		displayId: 'deliveryVsInvoice',
		labels: ['Invoice Net Gallons', 'Invoiced Deliveries'],
	},
	{
		sortId: 'finalCost',
		displayId: 'costsDisplay',
		label: 'Costs',
	},
	{
		sortId: 'viewButton',
		displayId: 'viewButton',
		label: 'Details',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class InventoryAllocations extends FormComponent {
	constructor(props) {
		super(props);

		let yearMonth = _.get(this.props, ['match', 'params', 'yearMonth']);

		const savedYearMonth = localStorage.getItem('inventoryAllocation.yearMonth');
		if (savedYearMonth) {
			yearMonth = savedYearMonth;
		}

		this.state = {
			yearMonth: yearMonth ? yearMonth : moment().format('YYYY-MM'),
			order: 'desc',
			orderBy: 'contractId',
			search: '',
			filterMap: {},
			inventoryAllocations: undefined,
			isFetching: true,
		};
	}

	componentDidMount() {
		this.getInventoryAllocation();
	}

	componentDidUpdate(prevProps, prevState) {
		const { inventoryAllocationsByYearMonth } = this.props;
		const { yearMonth } = this.state;

		//- THis has to also check for the state to be updated based on the container
		if (prevState.yearMonth !== yearMonth) {
			this.setState({ inventoryAllocations: undefined });
			localStorage.setItem('inventoryAllocation.yearMonth', yearMonth);
			this.getInventoryAllocation();
		}

		if (
			_.isUndefined(prevProps.inventoryAllocationsByYearMonth[yearMonth]) &&
			inventoryAllocationsByYearMonth[yearMonth]
		) {
			this.formatInventoryAllocation({
				inventoryAllocations: inventoryAllocationsByYearMonth[yearMonth],
			});
		}
	}

	getInventoryAllocation = () => {
		const { inventoryAllocationsByYearMonth, inventoryAllocationSearch } = this.props;
		const { yearMonth } = this.state;

		// See if we need to fetch or not
		if (!inventoryAllocationsByYearMonth || !inventoryAllocationsByYearMonth[yearMonth]) {
			this.setState({ isFetching: true });
			const yearMonthMoment = yearMonth ? moment(yearMonth, 'YYYY-MM') : moment();
			inventoryAllocationSearch({
				month: yearMonthMoment.month(),
				year: yearMonthMoment.year(),
			});
		} else {
			this.formatInventoryAllocation({
				inventoryAllocations: inventoryAllocationsByYearMonth[yearMonth],
			});
		}
	};

	formatInventoryAllocation = ({ inventoryAllocations }) => {
		const { fuelContractMap, supplierMap, terminalMap } = this.props;

		//- get the quarters
		const { classes } = this.props;
		inventoryAllocations.forEach((inventoryAllocation) => {
			const {
				inventoryAllocationId,
				supplierForTerminalId,
				contractLoadingNumber,
				allocatedForTerminalId,
				productType,
				allocationSources,
				totalByInvoice,
				totalByDeliveryThatAlsoHasInvoice,
				totalAllocation,
				totalByDelivery,
				finalCost,
				fuelMaintenanceCostPerGallon,
				fuelBlendedCost,
			} = inventoryAllocation;

			const supplier = supplierMap[supplierForTerminalId] || { name: 'Missing' };
			const terminal = terminalMap[allocatedForTerminalId] || { name: 'Missing' };
			const fuelDisplay = valueToDisplay(productType);
			inventoryAllocation.key = inventoryAllocationId;

			inventoryAllocation.terminalSupplierSort = terminal.name;
			inventoryAllocation.terminalSupplierDisplay = (
				<div>
					<div>Terminal : {terminal.name}</div>
					<div>Supplier : {supplier.name}</div>
					{contractLoadingNumber && <div>Loading # : {contractLoadingNumber}</div>}
					<div>Fuel : {fuelDisplay}</div>
				</div>
			);

			const allocationSourcesByReason = _.groupBy(allocationSources, 'allocationReason');
			/** @namespace allocationSourcesByReason.activeContract **/
			const activeContracts = _.sortBy(
				allocationSourcesByReason.activeContract,
				'allocationAmount'
			);
			let activeContract;
			if (!_.isEmpty(activeContracts)) {
				activeContract = _.first(activeContracts);
				const { fuelContractId } = activeContract;
				const fuelContract = fuelContractMap[fuelContractId] || { sourceCustomer: 'Missing' };
				inventoryAllocation.activeContractsSort = fuelContract.sourceCustomer;
				inventoryAllocation.activeContractsDisplay = activeContracts.map((allocationSource) => {
					const { fuelContractId } = allocationSource;

					const fuelContract = fuelContractMap[fuelContractId] || { sourceCustomer: 'Missing' };
					const { sourceCustomer, contractNumber } = fuelContract;

					return (
						<div key={`${inventoryAllocationId}_${fuelContractId}`}>
							<div>Source : {sourceCustomer}</div>
							<div className={classes.contractNumber}>Contract : {contractNumber}</div>
						</div>
					);
				});
			}

			const remaining = totalAllocation - totalByDelivery;
			inventoryAllocation.totalAllocationDisplay = (
				<div>
					<div>Total : {totalAllocation.toLocaleString()}</div>
					<div>All Deliveries : {totalByDelivery.toLocaleString()}</div>
					<div>
						<strong>Remaining : {remaining.toLocaleString()}</strong>
					</div>
				</div>
			);
			inventoryAllocation.allocationSourcesSort = totalAllocation;
			inventoryAllocation.allocationSourcesDisplay = _.values(allocationSourcesByReason).map(
				(allocationSources) => {
					let reasonDisplay = '';
					let total = 0;
					allocationSources.forEach((allocationSource) => {
						const { allocationReason, allocationAmount } = allocationSource;
						total += allocationAmount;
						reasonDisplay = reasonToDisplay[allocationReason] || 'Missing';
					});

					return (
						<div key={reasonDisplay}>
							<div>
								{reasonDisplay} : {total.toLocaleString()}
							</div>
						</div>
					);
				}
			);

			if (activeContract) {
				inventoryAllocation.quickAddRollover = (
					<IconButton
						color="primary"
						onClick={() => this.handleQuickAddRollover(activeContract.fuelContractId)}
					>
						<AddIcon />
					</IconButton>
				);
			}
			inventoryAllocation.deliveryVsInvoiceDiff =
				totalByInvoice - totalByDeliveryThatAlsoHasInvoice;

			inventoryAllocation.deliveryVsInvoice = (
				<div>
					<div>From Invoice : {totalByInvoice.toLocaleString()}</div>
					<div>From Delivery : {totalByDeliveryThatAlsoHasInvoice.toLocaleString()}</div>
					<div>Diff : {inventoryAllocation.deliveryVsInvoiceDiff.toLocaleString()}</div>
				</div>
			);
			inventoryAllocation.viewButton = (
				<Button className={classes.button} onClick={() => this.handleView(inventoryAllocationId)}>
					View
				</Button>
			);

			inventoryAllocation.costsDisplay = (
				<div>
					<div>
						Blended Fuel :{!fuelBlendedCost && <span> n/a</span>}
						{!!fuelBlendedCost && <span> {_.round(fuelBlendedCost, 4)}</span>}
					</div>
					<div>Maintenance : {_.round(fuelMaintenanceCostPerGallon, 4)}</div>
					<div style={{ fontWeight: 900 }}>
						Final :{!finalCost && <span> n/a</span>}
						{!!finalCost && <span> {_.round(finalCost, 4)}</span>}
					</div>
				</div>
			);
		});
		this.setState({ inventoryAllocations, isFetching: false });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleView = (inventoryAllocationId) => {
		const { yearMonth } = this.state;
		this.props.history.push(
			`/inventoryManagement/inventoryAllocation/details/${inventoryAllocationId}/${yearMonth}`
		);
	};

	handleQuickAddRollover = (fuelContractId) => {
		this.props.history.push(`/inventoryManagement/additionalFuelAllocation/add/${fuelContractId}`);
	};

	render() {
		const {
			classes,
			canRwInventoryAllocation,
			inventoryAllocationWarningsByYearMonth,
		} = this.props;

		const { inventoryAllocations, yearMonth, isFetching } = this.state;

		if (!canRwInventoryAllocation) {
			return <div>You have invalid permissions to view this page.</div>;
		}

		let warnings = [];
		if (_.isObject(inventoryAllocationWarningsByYearMonth)) {
			warnings = inventoryAllocationWarningsByYearMonth[yearMonth];
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Inventory Allocations"
						value={this.state.search}
						// onChange={this.handleSearch}
						buttonText="ADD ADDITIONAL ALLOCATION"
						url="/inventoryManagement/additionalFuelAllocation/add"
						canMakeUpdates={canRwInventoryAllocation}
					/>

					<div style={{ textAlign: 'left' }}>
						<FMPMonthYearPicker {...this.setForm('yearMonth')} md={4} />
					</div>

					{!_.isEmpty(warnings) && this.renderWarnings(warnings)}

					<Paper className={classes.paper}>
						{isFetching && <div>Loading inventory allocation...</div>}

						{!isFetching && <EnhancedTable columns={columns} rows={inventoryAllocations} />}
					</Paper>
				</Grid>
			</Grid>
		);
	}
	renderWarnings = (warnings) => {
		const { classes } = this.props;
		return (
			<Paper className={classes.paper} style={{ marginBottom: 20, marginTop: 10 }}>
				<div style={{ paddingBottom: 10, fontSize: '120%' }}>
					<WarningIcon className={classes.warningIcon} />
					<strong>Allocation Warnings</strong>
				</div>
				{warnings.map((warning, i) => {
					return (
						<div key={i} style={{ padding: 5 }}>
							{warning}
						</div>
					);
				})}
			</Paper>
		);
	};
}

InventoryAllocations.propTypes = {
	classes: PropTypes.object.isRequired,
	inventoryAllocationSearch: PropTypes.func.isRequired,
	inventoryAllocationsByYearMonth: PropTypes.object,
	inventoryAllocationWarningsByYearMonth: PropTypes.object,
	showErrors: PropTypes.func.isRequired,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,

	canRwInventoryAllocation: PropTypes.bool,
};

export default _.flow([withStyles(styles, { withTheme: true }), InventoryAllocationsContainer])(
	InventoryAllocations
);
